import React, { Fragment, useState } from 'react';
import Container from '../../../constants/Container';
import SecHeading from '../../../constants/SecHeading';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess } from '../../../constants/Toast';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../helpers/handleChange';
import SelectInputBox from '../../../constants/SelectInputBox';
import { MenuOptions, SubMenuOptions, YesNoOptions } from '../../../constants/Options';
import { Button } from '../../../constants/Button';
import { EndBaseLine } from '../../../constants/AppSpace';
import { MenuProps } from '../../../helpers/models/Models';
import useFetchSubData from '../../../helpers/useSubFetch';

const MenuCreateFromView: React.FC<{ data: MenuProps[], loading: boolean }> = ({ data, loading }) => {
    const initialValues = {
        name: "",
        name_nep: "",
        des: "",
        link: "",
        title: "",
        priority: "",
        component: "",
        sidedrawer: "",
        showmenu: "",
        menu: "",
        sub_menu: ""
    };

    const { values, errors, touched, resetForm, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("name", values.name);
            formData.append("name_nep", values.name_nep);
            formData.append("des", values.des);
            formData.append("link", values.link);
            formData.append("title", values.title);
            formData.append("priority", values.priority);
            formData.append("component", values.component);
            formData.append("sidedrawer", values.sidedrawer === "1" ? "true" : "false");
            formData.append("showmenu", values.showmenu === "1" ? "true" : "false");
            formData.append("sub_m_id", values.sub_menu);
            try {
                await postDataToTheServer(AppURL.ApplicationURL + "app/sub/sub/menu/create/view/", formData).then((res) => {
                    action.resetForm();
                    if (res?.status === 201) {
                        ToastSuccess({message: res?.message});
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    const menuOptions = MenuOptions(data);
    const { data: subMenuList, loading: subLoading, error } = useFetchSubData(AppURL.ApplicationURL + "app/menu/sub/menu/list/details/view/?menu_id=" + values.menu, values.menu);
    const subMenuOptions = SubMenuOptions(subMenuList?.sub_menu);
    return (
        <Fragment>
            <Container padding={true}>
                <form onSubmit={handleSubmit}>
                    <SecHeading type='add' label='Sub Sub Menu' />
                    <Grid container columnSpacing={3} rowSpacing={0.5}>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <SelectInputBox
                                label="Menu"
                                options={menuOptions}
                                name='menu'
                                required={true}
                                optionSelect={(name, selectedOption) => {
                                    setFieldValue("sub_menu", '');
                                    handleSelectBox({ setFieldValue, name, value: selectedOption });
                                }}
                                isLoading={loading}
                                value={values.menu}
                                touched={touched.menu}
                            />

                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <SelectInputBox
                                label="Sub Menu"
                                options={subMenuOptions}
                                name='sub_menu'
                                required={true}
                                optionSelect={(name, selectedOption) => {
                                    handleSelectBox({ setFieldValue, name, value: selectedOption })
                                }}
                                isLoading={subLoading}
                                value={values.sub_menu}
                                touched={touched.sub_menu}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <InputTextBox
                                type='text'
                                name='name'
                                label='Menu Name'
                                handleChange={handleChange}
                                value={values.name}
                                error={errors.name}
                                handleBlur={handleBlur}
                                required={true}
                                touched={touched.name} />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <NepaliInputBox
                                label='Menu Name(Nepali)'
                                name='name_nep'
                                value={values.name_nep}
                                handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'name_nep' })}
                                required={true}
                                handleBlur={handleBlur}
                                error={errors.name_nep}
                                touched={touched.name_nep}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <InputTextBox
                                type='text'
                                label="Desc"
                                name='des'
                                handleChange={handleChange}
                                value={values.des}
                                error={errors.des}
                                handleBlur={handleBlur}
                                touched={touched.des}
                                required={true}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <InputTextBox
                                type='text'
                                label="Link"
                                name='link'
                                handleChange={handleChange}
                                value={values.link}
                                error={errors.link}
                                handleBlur={handleBlur}
                                touched={touched.link}
                                required={true}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <InputTextBox
                                type='text'
                                label="Title"
                                name='title'
                                handleChange={handleChange}
                                value={values.title}
                                error={errors.title}
                                handleBlur={handleBlur}
                                touched={touched.title}
                                required={true}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <InputTextBox
                                type='number'
                                label="Priority"
                                name='priority'
                                handleChange={handleChange}
                                value={values.priority}
                                error={errors.priority}
                                handleBlur={handleBlur}
                                touched={touched.priority}
                                required={true}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <InputTextBox
                                type='text'
                                label="Component"
                                name='component'
                                handleChange={handleChange}
                                value={values.component}
                                error={errors.component}
                                handleBlur={handleBlur}
                                touched={touched.component}
                                required={true}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <SelectInputBox
                                label="Show Menu"
                                options={YesNoOptions}
                                name='showmenu'
                                required={true}
                                optionSelect={(name, selectedOption) => {
                                    handleSelectBox({ setFieldValue, name, value: selectedOption })
                                }
                                }
                                value={values.showmenu}
                                touched={touched.showmenu}
                            />
                        </Grid>
                        <Grid item xl={3} lg={3} sm={6} md={3} xs={12}>
                            <SelectInputBox
                                label="Show Drawer"
                                options={YesNoOptions}
                                name='sidedrawer'
                                required={true}
                                optionSelect={(name, selectedOption) => {
                                    handleSelectBox({ setFieldValue, name, value: selectedOption })
                                }
                                }
                                value={values.sidedrawer}
                                touched={touched.sidedrawer}
                            />
                        </Grid>
                        <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                            <EndBaseLine top={18}>
                                <Button btn_type='save' type='submit' el='button' />
                            </EndBaseLine>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        </Fragment>
    );
};

export default MenuCreateFromView;
